module.exports = __webpack_public_path__ + "static/media/avatar_panda.9d49e581.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_panda.png
// module id = 392
// module chunks = 0